const scale = {
	px: '1px',
	0: '0',
	1: '0.25rem',
	2: '0.5rem',
	3: '0.75rem',
	4: '1rem',
	5: '1.25rem',
	6: '1.5rem',
	8: '2rem',
	10: '2.5rem',
	12: '3rem',
	16: '4rem',
	20: '5rem',
	24: '6rem',
	32: '8rem',
	40: '10rem',
	48: '12rem',
	56: '14rem',
	64: '16rem',
}

const useTailwind = (classes, type) => {
	if (!Array.isArray(type)) type = [type]
	classes = classes.split(' ')

	return type.map((key, i) => {
		const twClass = classes[i]
		const index = [...twClass.match(/^.*-(.*)$/)][1]

		if (!['width', 'height'].includes(key)) throw 'This hook only supports spacing variables'

		return scale[index]
	})
}

export default useTailwind
